import { useEffect, useState } from "react";
import { addressApi } from "../api/client.js";
import AddressForm from "./AddressForm.jsx";
import { FarmLoader } from "./FarmLoader.jsx";

export default function AddressBook() {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [adding, setAdding] = useState(false);
  const [editing, setEditing] = useState(null);

  const refresh = async () => {
    setLoading(true);
    try {
      const { addresses: list } = await addressApi.list();
      setAddresses(list || []);
    } catch {
      setAddresses([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void refresh();
  }, []);

  const create = async (payload) => {
    try {
      await addressApi.create(payload);
      setAdding(false);
      refresh();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e.message };
    }
  };
  const update = async (id, payload) => {
    try {
      await addressApi.update(id, payload);
      setEditing(null);
      refresh();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e.message };
    }
  };
  const remove = async (id) => {
    try {
      await addressApi.remove(id);
      refresh();
    } catch {
      /* ignore */
    }
  };

  if (loading) return <FarmLoader message="Loading addresses…" size="sm" />;

  return (
    <div>
      {addresses.length === 0 && !adding && (
        <div className="account__empty"><p>No saved addresses yet.</p></div>
      )}

      <div className="addr-list">
        {addresses.map((a) =>
          editing === a.id ? (
            <div className="addr-card" key={a.id}>
              <AddressForm
                initial={a}
                submitLabel="Update address"
                onSave={(p) => update(a.id, p)}
                onCancel={() => setEditing(null)}
              />
            </div>
          ) : (
            <div className="addr-card" key={a.id}>
              <div className="addr-card__head">
                <strong>{a.label || "Address"}</strong>
                {a.isDefault && <span className="addr-card__default">Default</span>}
              </div>
              <p className="addr-card__body">
                {a.name} · {a.phone}<br />
                {a.line1}{a.line2 ? `, ${a.line2}` : ""}<br />
                {a.city}, {a.state} {a.pincode}
              </p>
              <div className="addr-card__actions">
                <button onClick={() => setEditing(a.id)}>Edit</button>
                <button className="addr-card__del" onClick={() => remove(a.id)}>Delete</button>
              </div>
            </div>
          )
        )}
      </div>

      {adding ? (
        <div className="addr-card">
          <AddressForm onSave={create} onCancel={() => setAdding(false)} />
        </div>
      ) : (
        <button className="btn btn--ghost" onClick={() => setAdding(true)}>+ Add new address</button>
      )}
    </div>
  );
}
